export default __webpack_public_path__ + "static/media/user.169ceb4d.png";